/* ============================================================
   KAMAKHYA — Motion controller
   ~1KB, no dependencies. Drives [data-reveal] via
   IntersectionObserver and auto-staggers grouped children.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return; // CSS already shows everything; nothing to observe.

  function init() {
    // Auto-assign stagger index to children inside a reveal group.
    document.querySelectorAll('[data-reveal-group]').forEach(function (group) {
      var kids = group.querySelectorAll('[data-reveal]');
      kids.forEach(function (el, i) { el.style.setProperty('--k-i', i); });
    });

    var targets = document.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target); // reveal once, then stop watching
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
